import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

export default {
  start: (req) => {
    return axios
      .post(`${PORTAL_SERVICOS_BACKEND}/gdoc/sign/start`, req)
      .then(res => { return res.data; });
  },
  complete: (req) => {
    return axios
      .post(`${PORTAL_SERVICOS_BACKEND}/gdoc/sign/complete`, req)
      .then(res => { return res.data; });
  },
};